import { Link } from 'react-router-dom';

export const TermsPage = () => {
  return (
    <main className="pt-20" data-testid="terms-page">
      {/* Page Header */}
      <section className="page-header py-16 lg:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-amber-950 font-serif mb-4">
              Terms & Conditions
            </h1>
            <p className="text-stone-600">Last updated: December 2024</p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 section-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-stone prose-lg max-w-none">
            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">1. Agreement to Terms</h2>
            <p className="text-stone-600 mb-6">
              By accessing our website or using Buy Fusion's flooring installation services, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, please do not use our services.
            </p>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">2. Services</h2>
            <p className="text-stone-600 mb-6">
              Buy Fusion provides professional flooring installation services including hardwood, vinyl, laminate, tile, carpet installation, and floor repair for residential and commercial properties in the Los Angeles area and surrounding regions.
            </p>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">3. Estimates and Pricing</h2>
            <ul className="list-disc list-inside text-stone-600 mb-6 space-y-2">
              <li>All estimates are provided free of charge and are non-binding until a formal contract is signed.</li>
              <li>Pricing is based on the scope of work discussed during the consultation.</li>
              <li>Additional work discovered during installation may result in price adjustments, which will be communicated before proceeding.</li>
              <li>Material costs are subject to market conditions and may vary from initial estimates.</li>
            </ul>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">4. Payment Terms</h2>
            <ul className="list-disc list-inside text-stone-600 mb-6 space-y-2">
              <li>A deposit may be required before materials are ordered.</li>
              <li>Final payment is due upon completion of the project.</li>
              <li>We accept various payment methods including checks, credit cards, and bank transfers.</li>
              <li>Late payments may be subject to additional fees.</li>
            </ul>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">5. Scheduling and Access</h2>
            <p className="text-stone-600 mb-6">
              Customers must provide adequate access to the work area during scheduled installation times. Delays caused by customer unavailability may result in rescheduling fees. We strive to complete all projects within the estimated timeframe but cannot guarantee specific completion dates due to unforeseen circumstances.
            </p>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">6. Warranty</h2>
            <p className="text-stone-600 mb-6">
              We provide a workmanship warranty on all installations. The duration and terms of the warranty will be specified in your service agreement. Material warranties are provided by the respective manufacturers and are separate from our workmanship warranty.
            </p>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">7. Customer Responsibilities</h2>
            <ul className="list-disc list-inside text-stone-600 mb-6 space-y-2">
              <li>Clear the work area of furniture and personal belongings before installation.</li>
              <li>Ensure pets and children are kept away from the work area for safety.</li>
              <li>Provide accurate information about property conditions and any known issues.</li>
              <li>Inspect completed work and report any concerns promptly.</li>
            </ul>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">8. Limitation of Liability</h2>
            <p className="text-stone-600 mb-6">
              Buy Fusion's liability is limited to the cost of the services provided. We are not responsible for pre-existing conditions, damage caused by customer negligence, or issues arising from improper maintenance after installation.
            </p>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">9. Cancellation Policy</h2>
            <p className="text-stone-600 mb-6">
              Cancellations made before material ordering will receive a full refund of any deposits. Cancellations after materials have been ordered may be subject to restocking fees. Please contact us as soon as possible if you need to cancel or reschedule.
            </p>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">10. Governing Law</h2>
            <p className="text-stone-600 mb-6">
              These Terms and Conditions are governed by the laws of the State of California. Any disputes arising from these terms or our services shall be resolved in the courts of Los Angeles County, California.
            </p>

            <h2 className="text-2xl font-semibold text-amber-950 font-serif mb-4">11. Contact Information</h2>
            <div className="bg-stone-50 rounded-xl p-6 mb-6">
              <p className="text-stone-700">
                <strong>Buy Fusion - Premium Flooring Co.</strong><br />
                88 Sunset Boulevard<br />
                Los Angeles, CA 800134<br />
                Email: <a href="mailto:support@buyfusion.store" className="text-amber-600 hover:text-amber-700">support@buyfusion.store</a><br />
                Phone: <a href="tel:+18888791244" className="text-amber-600 hover:text-amber-700">+1-888-879-1244</a>
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-stone-200">
            <Link to="/" className="text-amber-600 hover:text-amber-700 font-medium">
              ← Back to Home
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default TermsPage;
